import { render, staticRenderFns } from "./FileFormModal.vue?vue&type=template&id=7151b770"
import script from "./FileFormModal.vue?vue&type=script&lang=js"
export * from "./FileFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports